import Ax from '@/api/axios';

const CachedRequest = new (class {
  constructor() {
    this.cache = {};
  }

  clear() {
    this.cache = {};
  }

  post(api, ...args) {
    if (!this.cache[api]) {
      this.cache[api] = Ax.post(api, ...args);
    }
    return this.cache[api]
      .catch((ex) => {
        this.cache[api] = null;
        throw ex;
      });
  }

  get(api, ...args) {
    if (!this.cache[api]) {
      this.cache[api] = Ax.get(api, ...args);
    }
    return this.cache[api]
      .catch((ex) => {
        this.cache[api] = null;
        throw ex;
      });
  }

  /**
   * 针对api进行缓存刷新
   * @param {*} api
   */
  refresh(api) {
    this.cache[api] = null;
    return this.post(api);
  }
})();

export default CachedRequest;
